import { useState, useEffect } from "react";
import Series from "../components/series";

const Center = () => {
    const [series, setSeries] = useState([]);
    const [seriesFiltred, setSeriesFiltred] = useState([]);
    const [texto, setText] = useState("");

    /* Sending data to useState to use it on page*/
    useEffect(() => {
        const getSeries = async () => {
            const seriesFromServer = await fetchSeries();
            setSeries(seriesFromServer);
            setSeriesFiltred(seriesFromServer);
        };
        getSeries();
    }, []);

    /* Fetching from a URL data */
    const fetchSeries = async () => {
        const res = await fetch("https://shynden.netlify.app/gu.json", {
            headers: {
                "Access-Control-Allow-Origin": "application/json",
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        });
        const data = await res.json();

        return data.data;
    };

    const handleChange = (e) => {
        const keyword = e.target.value;

        if (keyword !== "") {
            const results = series.filter((item) => {
                return item.title.toLowerCase().startsWith(keyword.toLowerCase());
            });
            setSeriesFiltred(results);
        } else {
            setSeriesFiltred(series);
        }

        setText(keyword);
    };

    return (
        <div key={2} className="Main-center">
            <br />
            <input value={texto} className="writer" type="text" placeholer="Wpisuj" onChange={(e) => handleChange(e)}></input>
            <div className="Box">
                {seriesFiltred.map((serie) => {
                    return <Series key={serie.id} serie={serie} />;
                })}
            </div>
        </div>
    );
};

export default Center;
